import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="site-header sticky top-0 z-50 py-2 sm:py-0 px-4 sm:px-6 lg:px-8 shadow-md">
      <div className="container mx-auto">
        <div className="flex items-center relative">
          {/* Logo and Title Section */}
          <div className="flex items-center">
            {/* Logo - stays on the left for both mobile and desktop */}
            <Link to="/">
              <img src="/img/logo.png" alt="Refresh Bulgaria Logo" className="logo-image w-14 h-14 sm:w-20 sm:h-20 object-contain z-10" />
            </Link>
            
            {/* Desktop Title - visible only on desktop, positioned right after logo */}
            <Link to="/" className="hidden md:flex items-center ml-3">
              <span className="header-title text-white font-bold text-xl">Refresh<span className="text-green-200">Bulgaria</span></span>
            </Link>
          </div>
          
          {/* Mobile Title - centered absolutely, visible only on mobile */}
          <div className="absolute left-0 right-0 flex justify-center md:hidden">
            <Link to="/" className="flex items-center">
              <span className="header-title text-white font-bold text-xl">Refresh<span className="text-green-200">Bulgaria</span></span>
            </Link>
          </div>

          {/* Desktop Navigation and Mobile Menu Button - pushed to the right */}
          <div className="ml-auto flex items-center">
            <nav className="desktop-nav hidden md:flex items-center space-x-6">
              <NavLink to="/about" 
                className={({ isActive }) => 
                  isActive 
                    ? "nav-item text-white hover:text-green-100 transition-colors duration-300 border-b-2 border-white" 
                    : "nav-item text-white hover:text-green-100 transition-colors duration-300"
                }
              >
                За нас
              </NavLink>
              <NavLink to="/events" 
                className={({ isActive }) => 
                  isActive 
                    ? "nav-item text-white hover:text-green-100 transition-colors duration-300 border-b-2 border-white" 
                    : "nav-item text-white hover:text-green-100 transition-colors duration-300"
                }
              >
                Събития
              </NavLink>
              <NavLink to="/get-involved" 
                className={({ isActive }) => 
                  isActive 
                    ? "nav-item text-white hover:text-green-100 transition-colors duration-300 border-b-2 border-white" 
                    : "nav-item text-white hover:text-green-100 transition-colors duration-300"
                }
              >
                Включете се
              </NavLink>
              <NavLink to="/contacts" 
                className={({ isActive }) => 
                  isActive 
                    ? "nav-item text-white hover:text-green-100 transition-colors duration-300 border-b-2 border-white" 
                    : "nav-item text-white hover:text-green-100 transition-colors duration-300"
                }
              >
                Контакти
              </NavLink>
              <a 
                href="https://www.paypal.com/donate/?hosted_button_id=WRAX5VQQ7TZ4U" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-white hover:bg-green-50 text-green-800 font-semibold py-2 px-4 rounded-lg transition-colors duration-300 text-sm"
              >
                Дарете
              </a>
            </nav>

            {/* Mobile Menu Button (hamburger icon) */}
            <button 
              onClick={toggleMenu}
              className="md:hidden text-white p-2 z-10" 
              aria-label="Toggle menu" 
              aria-expanded={isMenuOpen}
            >
              <svg className={`hamburger-icon w-6 h-6 ${isMenuOpen ? 'active' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className={`md:hidden py-2 rounded-lg bg-white ${isMenuOpen ? 'expanded' : ''}`}>
          <nav className="mobile-menu-nav flex flex-col space-y-2 px-4">
            <NavLink to="/about" 
              className={({ isActive }) => 
                isActive 
                  ? "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md bg-green-100" 
                  : "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md"
              }
              style={{ '--item-index': 0 }}
            >
              За нас
            </NavLink>
            <NavLink to="/events" 
              className={({ isActive }) => 
                isActive 
                  ? "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md bg-green-100" 
                  : "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md"
              }
              style={{ '--item-index': 3 }}
            >
              Събития
            </NavLink>
            <NavLink to="/get-involved" 
              className={({ isActive }) => 
                isActive 
                  ? "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md bg-green-100" 
                  : "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md"
              }
              style={{ '--item-index': 4 }}
            >
              Включете се
            </NavLink>
            <NavLink to="/contacts" 
              className={({ isActive }) => 
                isActive 
                  ? "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md bg-green-100" 
                  : "nav-item text-green-800 hover:text-green-600 py-2 px-3 rounded-md"
              }
              style={{ '--item-index': 5 }}
            >
              Контакти
            </NavLink>
          </nav>
          
          {/* Donation Button - Separate from Navigation */}
          <div className="px-4 pt-3 pb-2 border-t border-green-100">
            <a 
              href="https://www.paypal.com/donate/?hosted_button_id=WRAX5VQQ7TZ4U" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-full bg-white hover:bg-green-50 text-green-700 border-2 border-green-600 font-semibold py-3 px-4 rounded-lg transition-colors duration-300 shadow-sm"
            >
              Дарете
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 